'use strict';
var parent = require('../../es/object/keys');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/object/keys.js
// module id = 779
// module chunks = 13